module.exports = __webpack_public_path__ + "img/17.86fb76ec.png";